import { matchPath } from 'react-router';

import {
  STEPS,
  BRANDS,
  SEARCH,
  PERIOD,
  AUTHORS,
  MODULES,
  SENDERS,
  NOT_EXIST,
  START_DATE_TO,
  ASSIGNEE_USERS,
  MOBILITY_FLAGS,
  START_DATE_FROM,
  ADVISOR_USERS,
  ADVISOR_USER_GROUPS,
  ASSIGNEE_USER_GROUPS,
} from 'constants/FilterConstants';
import { DATE_TYPE } from 'constants/InterventionConstants';
import { PATH } from 'constants/RoutesConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

const persistedFilters = getPersistedFilters()?.filters?.mobility ?? {};

/** @typedef {'modules' | 'stepIds' | 'text' | 'senders' | 'brands' | 'assignedUserGroupIds' | 'assignedUserIds' | 'authors' | 'mobilityFlags' | 'startDateFrom' | 'startDateTo' | 'period' | 'notExist' } FilterField */

/** @typedef {Record<FilterField, string | number | Array<string> | Array<number>>} MobilityFiltersReducer */

/** @type {MobilityFiltersReducer} */
const emptyState = {
  [STEPS]: [],
  [BRANDS]: [],
  [AUTHORS]: [],
  [MODULES]: [],
  [SENDERS]: [],
  [SEARCH]: null,
  [NOT_EXIST]: [],
  [MOBILITY_FLAGS]: [],
  [ASSIGNEE_USERS]: [],
  [ASSIGNEE_USER_GROUPS]: [],
  [ADVISOR_USERS]: [],
  [ADVISOR_USER_GROUPS]: [],
  [PERIOD]: DATE_TYPE.PLANNED,
  startDateFrom: new Date().toISOString(),
  startDateTo: null,
};

const updateDateUpdate = filters => ({
  ...filters,
  [START_DATE_FROM]: filters.period === DATE_TYPE.PLANNED ? new Date().toISOString() : filters[START_DATE_FROM],
  [START_DATE_TO]: filters.period === DATE_TYPE.CURRENT ? new Date().toISOString() : filters[START_DATE_TO],
});

/** @type {FilterAdapter<MobilityFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(
  filterAdapter.getInitialState(),
  {
    [types.SET_MOBILITY_INTERVENTION_FILTER]: filterAdapter.setFilter,
    [types.SET_MOBILITY_INTERVENTION_FILTERS]: filterAdapter.setFilters,
    [types.CLEAR_MOBILITY_INTERVENTION_FILTER]: filterAdapter.resetFilters,
    [types.REMOVE_MOBILITY_INTERVENTION_FILTER]: filterAdapter.removeFilter,
  },
  [
    {
      matcher: ({ type, payload }) =>
        type === LOCATION_CHANGE && matchPath(PATH.SELF_SERVICE_MOBILITY.path, payload.location.pathname),
      reducer: updateDateUpdate
    },
  ]
);
